import React, { FunctionComponent, useEffect, useState } from 'react';
import { SearchBox as HeadlessSearchBox } from '@coveo/headless';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import '../SearchPage/index.scss';
import { FaSearch } from 'react-icons/fa';
import { Navigate, useLocation } from 'react-router-dom';
import { Field } from '@sitecore-jss/sitecore-jss-react';
import { InfoPopup } from '../InfoPopup/InfoPopup';

export interface SearchBoxProps {
  controller: HeadlessSearchBox;
  fields?: {
    'Popup Text': Field<string>;
  };
}

export const SearchBox: FunctionComponent<SearchBoxProps> = (props) => {
  const { controller } = props;
  const [navigateSearch, setNavigateSearch] = useState(false);
  const [state, setState] = useState(controller.state);
  const loc = useLocation();

  const isEnterKey = (e: React.KeyboardEvent) => e.key === 'Enter';
  useEffect(() => {
    const unsubscribe = controller.subscribe(() => {
      setState(controller.state);
    });

    return () => unsubscribe();
  }, [controller]);

  const navigateToSearch = () => {
    if (loc.pathname !== '/standards') {
      setNavigateSearch(true);
    } else {
      controller.submit();
    }
  };

  return (
    <div className="searchFieldWrapper bg-info-toolip">
      <Autocomplete
        className="siteSearchField"
        inputValue={state.value}
        onInputChange={(_, newInputValue: string) => {
          controller.updateText(newInputValue);
        }}
        onKeyDown={(e) => isEnterKey(e) && navigateToSearch()}
        options={state.suggestions}
        getOptionLabel={(option: any) => (typeof option === 'object' ? option.rawValue : option)}
        renderOption={(props, option: any) => (
          <li {...props}>
            <div
              dangerouslySetInnerHTML={{
                __html: option.highlightedValue,
              }}
            />
          </li>
        )}
        sx={{
          '& .MuiFormControl-root': { height: '100%' },
          '& .MuiInputBase-root': { height: '100%' },
        }}
        slotProps={{
          paper: {
            sx: {
              '& .MuiAutocomplete-option': {
                fontSize: '2rem',
              },
              '& .MuiAutocomplete-option.Mui-focused, \
               & .MuiAutocomplete-option.Mui-focusVisible, \
               & .MuiAutocomplete-option[aria-selected="true"], \
               & .MuiAutocomplete-option:hover': {
                backgroundColor: 'rgba(0,0,0,0.04) !important',
                color: 'rgba(0,0,0,0.87) !important',
              },
            },
          },
        }}
        freeSolo
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Search Standards and Training"
            className="no-border-box"
            variant="outlined"
            size="small"
          />
        )}
      />

      <button className="SearchIcon" onClick={navigateToSearch}>
        <FaSearch />
      </button>

      <div className="helpIconWrapper">
        {props.fields?.['Popup Text'] && (
          <InfoPopup fields={{ 'Popup Text': props.fields['Popup Text'] }} />
        )}
      </div>

      {navigateSearch ? <Navigate to={`/standards${loc.hash.slice(1)}`} /> : null}
    </div>
  );
};

export default SearchBox;
